import { render, staticRenderFns } from "./TfacStudentInfoPanel.vue?vue&type=template&id=13736762&scoped=true"
import script from "./TfacStudentInfoPanel.vue?vue&type=script&lang=js"
export * from "./TfacStudentInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./TfacStudentInfoPanel.vue?vue&type=style&index=0&id=13736762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13736762",
  null
  
)

export default component.exports